module.exports = __webpack_public_path__ + "img/big-gift.7ca9b25b.png";